import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApplikasiKreditService from "services/Setup/LoanOrigination/Loan/ApplikasiKreditService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  loadingGeneral: false,
  loadingPosGeneral: false,
  loadingGuarantor: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  creditStepKTA: "GN",
  applicationID: "",
  apkLoanItem: [],
  loanSurveyList: [],
  apkLoanItemCST: [],
  apkLoanItemCAS: [],
  loanCreditScoring: [],
  ApkLoanGuarantorItem: [],

 
  characterSurveyList: [],
  capacitySurveyList: [],
  conditionSurveyList: [],
  capitalSurveyList: [],
  collateralSurveyList: [],
  catatanSurveyList: [],
  catatanSurveyDocList: [],
  KYCSurveyDocumentList: [],
  KYCSurveyList: [],

  teleVerificationKKBAssessmentItemList: [],

  statusRespon: 0,
  statusResponCreditAssessment: 0,
  statusResponProceedKKB: 0,
};

export const postGeneral = createAsyncThunk(
  "ApplikasiKredit/postGeneral",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.postGeneral(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putGuarantor = createAsyncThunk(
  "ApplikasiKredit/putGuarantor",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.putGuarantor(userInput);
      console.log("responseputGuarantor", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getGetApkLoanItem = createAsyncThunk(
  "ApplikasiKredit/getGetApkLoanItem",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.getGetApkLoanItem(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getGetApkLoanItemCST = createAsyncThunk(
  "ApplikasiKredit/getGetApkLoanItemCST",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.getGetApkLoanItemCST(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getGetApkLoanItemCAS = createAsyncThunk(
  "ApplikasiKredit/getGetApkLoanItemCAS",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.getGetApkLoanItemCAS(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getApkLoanCreditScoring = createAsyncThunk(
  "ApplikasiKredit/getApkLoanCreditScoring",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoanCreditScoring", prospectid);

    try {
      const response = await ApplikasiKreditService.getApkLoanCreditScoring(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getEditApkLoanGuarantorSlice = createAsyncThunk(
  "ApplikasiKredit/getEditApkLoanGuarantorSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.getEditApkLoanGuarantorService(prospectid);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addApkLoanGuarantorSlice = createAsyncThunk(
  "ApplikasiKredit/addApkLoanGuarantorSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.addApkLoanGuarantorService(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getDetailSlice = createAsyncThunk(
  "ApplikasiKredit/getDetailSlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetDetailSlice", prospectid);

    try {
      const response = await ApplikasiKreditService.getDetailSurvey(prospectid);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getApkLoanSurveySlice = createAsyncThunk(
  "ApplikasiKredit/getApkLoanSurveySlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getApkLoanSurveyService(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postLoanSlice = createAsyncThunk(
  "ApplikasiKredit/postLoanSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.postLoanService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putLoanSlice = createAsyncThunk(
  "ApplikasiKredit/putLoanSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.putLoanService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCharacterSlice = createAsyncThunk(
  "ApplikasiKredit/getCharacterSlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getCharacterSurvey(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addApkLoanCharacterSurveySlice = createAsyncThunk(
  "ApplikasiKredit/addApkLoanCharacterSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.addApkLoanCharacterSurveyService(
          userInput
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApkLoanCharacterSurveySlice = createAsyncThunk(
  "ApplikasiKredit/putApkLoanCharacterSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.putApkLoanCharacterSurveyService(
          userInput
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getConditionSurveySlice = createAsyncThunk(
  "ApplikasiKredit/getConditionSurveySlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getConditionSurveyService(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addApkLoanConditionSurveySlice = createAsyncThunk(
  "ApplikasiKredit/addApkLoanConditionSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.addApkLoanConditionSurveyService(
          userInput
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApkLoanConditionSurveySlice = createAsyncThunk(
  "ApplikasiKredit/putApkLoanConditionSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.putApkLoanConditionSurveyService(
          userInput
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCapitalSurveySlice = createAsyncThunk(
  "ApplikasiKredit/getCapitalSurveySlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getCapitalSurveyService(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addApkLoanCapitalSurveySlice = createAsyncThunk(
  "ApplikasiKredit/addApkLoanCapitalSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.addApkLoanCapitalSurveyService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApkLoanCapitalSurveySlice = createAsyncThunk(
  "ApplikasiKredit/putApkLoanCapitalSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.putApkLoanCapitalSurveyService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCapacitySurveySlice = createAsyncThunk(
  "ApplikasiKredit/getCapacitySurveySlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getCapacitySurveyService(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addApkLoanCapacitySurveySlice = createAsyncThunk(
  "ApplikasiKredit/addApkLoanCapacitySurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.addApkLoanCapacitySurveyService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApkLoanCapacitySurveySlice = createAsyncThunk(
  "ApplikasiKredit/putApkLoanCapacitySurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.putApkLoanCapacitySurveyService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCollateralSurveySlice = createAsyncThunk(
  "ApplikasiKredit/getCollateralSurveySlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getCollateralSurveyService(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addApkLoanCollateralSurveySlice = createAsyncThunk(
  "ApplikasiKredit/addApkLoanCollateralSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.addApkLoanCollateralSurveyService(
          userInput
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const editApkLoanCollateralSurveySlice = createAsyncThunk(
  "ApplikasiKredit/editApkLoanCollateralSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.editApkLoanCollateralSurveyService(
          userInput
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCatatanSurveySlice = createAsyncThunk(
  "ApplikasiKredit/getCatatanSurveySlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getCatatanSurveyService(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCatatanSurveyDocSlice = createAsyncThunk(
  "ApplikasiKredit/getCatatanSurveyDocSlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getCatatanSurveyDocService(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addApkLoanCatatanSurveySlice = createAsyncThunk(
  "ApplikasiKredit/addApkLoanCatatanSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.addApkLoanCatatanSurveyService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const editApkLoanCatatanSurveySlice = createAsyncThunk(
  "ApplikasiKredit/editApkLoanCatatanSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.editApkLoanCatatanSurveyService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getKYCSurveySlice = createAsyncThunk(
  "ApplikasiKredit/getKYCSurveySlice",
  async (prospectid, { rejectWithValue }) => {
    console.log("prospectidgetApkLoan", prospectid);

    try {
      const response = await ApplikasiKreditService.getKYCSurveyService(
        prospectid
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addKYCSurveySlice = createAsyncThunk(
  "ApplikasiKredit/addKYCSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.addKYCSurveyService(
        userInput
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getKYCSurveyDocumentSlice = createAsyncThunk(
  "ApplikasiKredit/getKYCSurveyDocumentSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.getKYCSurveyDocumentService(
        userInput
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const editKYCSurveySlice = createAsyncThunk(
  "ApplikasiKredit/editKYCSurveySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApplikasiKreditService.editKYCSurveyService(
        userInput
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addTeleVerificationKKBSlice = createAsyncThunk(
  "ApplikasiKredit/addTeleVerificationKKBSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.addTeleVerificationKKBService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getTeleVerificationKKBAssessmentItemSlice = createAsyncThunk(
  "ApplikasiKredit/getTeleVerificationKKBAssessmentItemSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.getTeleVerificationKKBAssessmentItemService(
          userInput
        );
      if (response.status === 200) {
        // if (response.data.status == "Success") {
        //   notification.success({
        //     message: response.data.status,
        //     description: response.data.message,
        //     duration: 3,
        //   });
        // } else {
        //   notification.error({
        //     message: response.data.status,
        //     description: response.data.message,
        //     duration: 3,
        //   });
        // }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const addChecklistCreditAssessmentSlice = createAsyncThunk(
  "ApplikasiKredit/addChecklistCreditAssessmentSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.addChecklistCreditAssessmentService(
          userInput
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const ProceedChecklistCreditAssessmentSlice = createAsyncThunk(
  "ApplikasiKredit/ProceedChecklistCreditAssessmentSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await ApplikasiKreditService.ProceedChecklistCreditAssessmentService(
          userInput
        );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const ApplikasiKredit = createSlice({
  name: "applikasiKredit",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStatusRespon: (state) => {
      state.statusRespon = 0;
    },
    setcreditStepKTA: (state, action) => {
      // console.log("codTab34567890-", action.payload);
      state.creditStepKTA = action.payload;
    },
    setApplicationID: (state, action) => {
      // console.log("codTab34567890-", action.payload);
      state.applicationID = action.payload;
    },

    resetDataAplikasiKTa: (state) => {
      state.loading = false;
      state.loadingGeneral = false;
      state.loadingPosGeneral = false;
      state.message = "";
      state.showMessage = false;
      state.redirect = "";
      state.result = {};
      state.productList = {};
      state.refreshList = false;
      state.getPageSize = "";
      state.getPageIndex = "";
      state.getCount = "";
      state.creditStepKTA = "GN";
      state.apkLoanItem = [];
      state.apkLoanItemCST = [];
      // state.loanCreditScoring = [];
      state.statusRespon = 0;
      state.statusResponCreditAssessment = 0;
      state.statusResponProceedKKB = 0;
    },
  },

  extraReducers: (builder) => {
    builder
      //   post
      .addCase(postGeneral.pending, (state) => {
        console.log("actionpostGuarantor applicationID");
        state.loadingPosGeneral = true;
      })
      .addCase(postGeneral.fulfilled, (state, action) => {
        state.loadingPosGeneral = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.applicationID = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(postGeneral.rejected, (state, action) => {
        state.loadingPosGeneral = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   put
      .addCase(putGuarantor.pending, (state) => {
        state.loadingGeneral = true;
      })
      .addCase(putGuarantor.fulfilled, (state, action) => {
        state.loadingGeneral = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.data?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(putGuarantor.rejected, (state, action) => {
        state.loadingGeneral = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //getGetApkLoanItem
      .addCase(getGetApkLoanItem.pending, (state) => {
        state.loadingGeneral = true;
        state.redirect = "";
      })
      .addCase(getGetApkLoanItem.fulfilled, (state, action) => {
        state.loadingGeneral = false;
        state.apkLoanItem = action.payload?.data || [];
        state.getCount = action.payload?.count || 0;
      })
      .addCase(getGetApkLoanItem.rejected, (state, action) => {
        state.loadingGeneral = false;
      })
      //getGetApkLoanItemCST
      .addCase(getGetApkLoanItemCST.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getGetApkLoanItemCST.fulfilled, (state, action) => {
        state.loading = false;
        state.apkLoanItemCST = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getGetApkLoanItemCST.rejected, (state, action) => {
        state.loading = false;
      })
      //getGetApkLoanItemCAS
      .addCase(getGetApkLoanItemCAS.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getGetApkLoanItemCAS.fulfilled, (state, action) => {
        state.loading = false;
        state.apkLoanItemCAS = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getGetApkLoanItemCAS.rejected, (state, action) => {
        state.loading = false;
      })
      //getApkLoanCreditScoring
      .addCase(getApkLoanCreditScoring.pending, (state) => {
        state.loadingGeneral = true;
        state.redirect = "";
      })
      .addCase(getApkLoanCreditScoring.fulfilled, (state, action) => {
        state.loadingGeneral = false;
        state.loanCreditScoring = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getApkLoanCreditScoring.rejected, (state, action) => {
        state.loadingGeneral = false;
      })
      // getDetailSlice
      .addCase(getDetailSlice.pending, (state) => {
        state.loadingGeneral = true;
        state.redirect = "";
      })
      .addCase(getDetailSlice.fulfilled, (state, action) => {
        state.loadingGeneral = false;
        state.loanSurveyList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getDetailSlice.rejected, (state, action) => {
        state.loadingGeneral = false;
      })
      //getApkLoanSurveySlice
      .addCase(getApkLoanSurveySlice.pending, (state) => {
        state.loadingGeneral = true;
        state.redirect = "";
      })
      .addCase(getApkLoanSurveySlice.fulfilled, (state, action) => {
        console.log("getApkLoanSurveySlice", action);
        
        state.loadingGeneral = false;
        state.loanSurveyList = action.payload?.data || [];
        state.getCount = action.payload && action.payload.count ? action.payload.count : 0;
      })
      .addCase(getApkLoanSurveySlice.rejected, (state, action) => {
        state.loadingGeneral = false;
      })
      //
      //getEditApkLoanGuarantorSlice
      .addCase(getEditApkLoanGuarantorSlice.pending, (state) => {
        state.loadingGeneral = true;
        state.redirect = "";
      })
      .addCase(getEditApkLoanGuarantorSlice.fulfilled, (state, action) => {
        state.loadingGeneral = false;
        state.ApkLoanGuarantorItem = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getEditApkLoanGuarantorSlice.rejected, (state, action) => {
        state.loadingGeneral = false;
      })
      //
      //addApkLoanGuarantorSlice
      .addCase(postLoanSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(postLoanSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(postLoanSlice.rejected, (state, action) => {
        state.loading = false;
      })
      // putLoanSlice
      .addCase(putLoanSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putLoanSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(putLoanSlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addApkLoanGuarantorSlice
      .addCase(addApkLoanGuarantorSlice.pending, (state) => {
        state.loadingGuarantor = true;
        state.redirect = "";
      })
      .addCase(addApkLoanGuarantorSlice.fulfilled, (state, action) => {
        // console.log('addApkLoanGuarantorSlice',action);

        state.loadingGuarantor = false;
        state.loanCreditScoring = action.payload?.data || [];
        state.getCount = action.payload.count;
        state.statusRespon = action.payload.status;
      })
      .addCase(addApkLoanGuarantorSlice.rejected, (state, action) => {
        state.loadingGuarantor = false;
      })
      // getCharacterSlice
      .addCase(getCharacterSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCharacterSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.characterSurveyList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getCharacterSlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addApkLoanCharacterSurveySlice
      .addCase(addApkLoanCharacterSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addApkLoanCharacterSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(addApkLoanCharacterSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // putApkLoanCharacterSurveySlice
      .addCase(putApkLoanCharacterSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putApkLoanCharacterSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(putApkLoanCharacterSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // getConditionSurveySlice
      .addCase(getConditionSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getConditionSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.conditionSurveyList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getConditionSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addApkLoanConditionSurveySlice
      .addCase(addApkLoanConditionSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addApkLoanConditionSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(addApkLoanConditionSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addApkLoanConditionSurveySlice
      .addCase(putApkLoanConditionSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putApkLoanConditionSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(putApkLoanConditionSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // getCapitalSurveySlice
      .addCase(getCapitalSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCapitalSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.capitalSurveyList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getCapitalSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addApkLoanCapitalSurveySlice
      .addCase(addApkLoanCapitalSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addApkLoanCapitalSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(addApkLoanCapitalSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // putApkLoanCapitalSurveySlice
      .addCase(putApkLoanCapitalSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putApkLoanCapitalSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(putApkLoanCapitalSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // getCapacitySurveySlice
      .addCase(getCapacitySurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCapacitySurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.capacitySurveyList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getCapacitySurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addApkLoanCapacitySurveySlice
      .addCase(addApkLoanCapacitySurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addApkLoanCapacitySurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(addApkLoanCapacitySurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // putApkLoanCapacitySurveySlice
      .addCase(putApkLoanCapacitySurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putApkLoanCapacitySurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(putApkLoanCapacitySurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // getCollateralSurveySlice
      .addCase(getCollateralSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCollateralSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.collateralSurveyList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getCollateralSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })

      //addApkLoanCollateralSurveySlice
      .addCase(addApkLoanCollateralSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addApkLoanCollateralSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(addApkLoanCollateralSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      //editApkLoanCollateralSurveySlice
      .addCase(editApkLoanCollateralSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(editApkLoanCollateralSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(editApkLoanCollateralSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // getCatatanSurveySlice
      .addCase(getCatatanSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCatatanSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.catatanSurveyList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getCatatanSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      // getCatatanSurveyDocSlice
      .addCase(getCatatanSurveyDocSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getCatatanSurveyDocSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.catatanSurveyDocList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getCatatanSurveyDocSlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addApkLoanCatatanSurveySlice
      .addCase(addApkLoanCatatanSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addApkLoanCatatanSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(addApkLoanCatatanSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      //editApkLoanCatatanSurveySlice
      .addCase(editApkLoanCatatanSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(editApkLoanCatatanSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(editApkLoanCatatanSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })

      // getKYCSurveySlice
      .addCase(getKYCSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getKYCSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.KYCSurveyList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getKYCSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })

      // getKYCSurveyDocumentSlice
      .addCase(getKYCSurveyDocumentSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getKYCSurveyDocumentSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.KYCSurveyDocumentList = action.payload?.data || [];
        state.getCount = action.payload.count;
      })
      .addCase(getKYCSurveyDocumentSlice.rejected, (state, action) => {
        state.loading = false;
      })

      // editKYCSurveySlice
      .addCase(editKYCSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(editKYCSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(editKYCSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addKYCSurveySlice
      .addCase(addKYCSurveySlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addKYCSurveySlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(addKYCSurveySlice.rejected, (state, action) => {
        state.loading = false;
      })
      //addTeleVerificationKKBSlice
      .addCase(addTeleVerificationKKBSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addTeleVerificationKKBSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusRespon = action.payload.status;
      })
      .addCase(addTeleVerificationKKBSlice.rejected, (state, action) => {
        state.loading = false;
      })
      //getTeleVerificationKKBAssessmentItemSlice
      .addCase(getTeleVerificationKKBAssessmentItemSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(
        getTeleVerificationKKBAssessmentItemSlice.fulfilled,
        (state, action) => {
          // console.log("teleVerificationKKBAssessmentItemList",action);

          state.loading = false;
          state.teleVerificationKKBAssessmentItemList = action.payload;
          state.getCount = action.payload.count;
        }
      )
      .addCase(
        getTeleVerificationKKBAssessmentItemSlice.rejected,
        (state, action) => {
          state.loading = false;
        }
      )
      //addChecklistCreditAssessmentSlice
      .addCase(addChecklistCreditAssessmentSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(addChecklistCreditAssessmentSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.statusResponCreditAssessment = action.payload.status;
      })
      .addCase(addChecklistCreditAssessmentSlice.rejected, (state, action) => {
        state.loading = false;
      })
      //ProceedChecklistCreditAssessmentSlice
      .addCase(ProceedChecklistCreditAssessmentSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(
        ProceedChecklistCreditAssessmentSlice.fulfilled,
        (state, action) => {
          state.loading = false;
          state.statusResponProceedKKB = action.payload.status;
        }
      )
      .addCase(
        ProceedChecklistCreditAssessmentSlice.rejected,
        (state, action) => {
          state.loading = false;
        }
      );
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
  setcreditStepKTA,
  resetDataAplikasiKTa,
  setApplicationID,
} = ApplikasiKredit.actions;

export default ApplikasiKredit.reducer;
